"use client";

import { c as _c } from "react/compiler-runtime";
import { ThemeProvider as NextThemesProvider, useTheme } from "next-themes";
import { type ComponentProps, useEffect } from "react";
import { Toaster } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
function ThemeProvider(t0) {
  const $ = _c(10);
  let children;
  let props;
  if ($[0] !== t0) {
    ({
      children,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = props;
  } else {
    children = $[1];
    props = $[2];
  }
  let t1;
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Toaster position="bottom-right" richColors={true} />;
    t2 = <ThemeHotkey />;
    $[3] = t1;
    $[4] = t2;
  } else {
    t1 = $[3];
    t2 = $[4];
  }
  let t3;
  if ($[5] !== children) {
    t3 = <TooltipProvider>{t1}{t2}{children}</TooltipProvider>;
    $[5] = children;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== props || $[8] !== t3) {
    t4 = <NextThemesProvider attribute="class" defaultTheme="system" disableTransitionOnChange={true} enableSystem={true} {...props}>{t3}</NextThemesProvider>;
    $[7] = props;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
}
function isTypingTarget(target: EventTarget | null) {
  if (!(target instanceof HTMLElement)) {
    return false;
  }
  return target.isContentEditable || target.tagName === "INPUT" || target.tagName === "TEXTAREA" || target.tagName === "SELECT";
}
function ThemeHotkey() {
  const $ = _c(4);
  const {
    resolvedTheme,
    setTheme
  } = useTheme();
  let t0;
  let t1;
  if ($[0] !== resolvedTheme || $[1] !== setTheme) {
    t0 = () => {
      const onKeyDown = function onKeyDown(event) {
        if (event.defaultPrevented || event.repeat || !event.key) {
          return;
        }
        if (event.metaKey || event.ctrlKey || event.altKey) {
          return;
        }
        if (event.key.toLowerCase() !== "d") {
          return;
        }
        if (isTypingTarget(event.target)) {
          return;
        }
        setTheme(resolvedTheme === "dark" ? "light" : "dark");
      };
      window.addEventListener("keydown", onKeyDown);
      return () => {
        window.removeEventListener("keydown", onKeyDown);
      };
    };
    t1 = [resolvedTheme, setTheme];
    $[0] = resolvedTheme;
    $[1] = setTheme;
    $[2] = t0;
    $[3] = t1;
  } else {
    t0 = $[2];
    t1 = $[3];
  }
  useEffect(t0, t1);
  return null;
}
export { ThemeProvider };